import React, {Component, Fragment} from 'react';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {EnteroSolo, FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {EstadoCuentasService} from "../../../../services/EstadoCuentasService/EstadoCuentasService";
import {BotonAccionAbrirModal} from "../../../Include/MiniComponents/GlobalComponent";
import {DateFormat} from "../../../../settings/DateFormat/DateFormat";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import carrito_de_compra_1 from "../../../../assets/img/icons/carro-de-la-compra-1.svg";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";
import {KeyboardDatePicker} from "@material-ui/pickers";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import DialogActions from "@material-ui/core/DialogActions";
import * as PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalUsuarios from "../../Usuarios/Includes/ModalUsuarios";
import ModalFondeoCuentaxId from "./ModalFondeoCuentaxId";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";
import {UsuariosService} from "../../../../services/_Sis/UsuariosService/UsuariosService";

class ModalFondeoCuenta extends Component {
	
	state = {};
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_fondeo_cuenta: (props.item || {}).id_fondeo_cuenta,
			importe: '',
			origen: '',
			observacion: '',
			activo: true,
			id_cat_tipo_ingreso_fondeo: '',
			id_cat_forma_pago_fondeo: '',
			id_cat_destino_fondeo: '',
			
			fecha_operacion: null,
			
			lista_cat_tipo_ingreso_fondeo: [],
			lista_cat_forma_pago_fondeo: [],
			lista_fondeos: []
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	ListaTipoIngresoFondeo = () => {
		CatService.ListTipoIngresoFondeo().then((response) => {
			this.setState({
				lista_cat_tipo_ingreso_fondeo: response.data
			});
		}).catch((error) => {
			this.setState({
				lista_cat_tipo_ingreso_fondeo: []
			});
			this.showSnackBars('error', error.mensaje);
		})
	};
	
	ListaFormaPagoFondeo = () => {
		CatService.ListFormaPagoFondeo().then((response) => {
			this.setState({
				lista_cat_forma_pago_fondeo: response.data
			});
		}).catch((error) => {
			this.setState({
				lista_cat_forma_pago_fondeo: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	ListaEstadoCuentaFondeo = () => {
		EstadoCuentasService.ListarFondeo().then((response) => {
			this.setState({
				lista_fondeos: response.data
			});
		}).catch((error) => {
			this.setState({
				lista_fondeos: []
			});
			this.showSnackBars('error', error.mensaje);
		})
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			
			this.ListaEstadoCuentaFondeo();
			this.ListaTipoIngresoFondeo();
			this.ListaFormaPagoFondeo();
			
			resolve(true);
		});
	};
	
	save = () => {
		if (this.state.id_fondeo_cuenta > 0) {
			EstadoCuentasService.ModificarFondeo(this.state).then((response) => {
				this.props.showSnackBars('success', response.mensaje);
				this.setState({
					importe: '',
					origen: '',
					observacion: '',
					id_cat_tipo_ingreso_fondeo: '',
					id_cat_forma_pago_fondeo: '',
					id_cat_destino_fondeo: '',
					fecha_operacion: null,
				});
				this.ListaEstadoCuentaFondeo();
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		} else {
			EstadoCuentasService.AgregarFondeo(this.state).then((response) => {
				this.props.showSnackBars('success', response.mensaje);
				this.setState({
					importe: '',
					origen: '',
					observacion: '',
					id_cat_tipo_ingreso_fondeo: '',
					id_cat_forma_pago_fondeo: '',
					id_cat_destino_fondeo: '',
					fecha_operacion: null,
				});
				this.ListaEstadoCuentaFondeo();
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		}
	};
	
	add = () => {
		console.log(this.props);
		this.setState({
			id_fondeo_cuenta: '',
			importe: '',
			origen: '',
			observacion: '',
			id_cat_tipo_ingreso_fondeo: '',
			id_cat_forma_pago_fondeo: '',
			id_cat_destino_fondeo: '',
			fecha_operacion: null,
			activo: true,
		});
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			id_fondeo_cuenta: item.id_fondeo_cuenta || '',
			importe: item.importe || '',
			origen: item.origen || '',
			observacion: item.observacion || '',
			id_cat_tipo_ingreso_fondeo: item.id_cat_tipo_ingreso_fondeo || '',
			id_cat_forma_pago_fondeo: item.id_cat_forma_pago_fondeo || '',
			id_cat_destino_fondeo: item.id_cat_destino_fondeo || '',
			fecha_operacion: item.fecha_operacion || null,
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			id_fondeo_cuenta: item.id_fondeo_cuenta || '',
			importe: item.importe || '',
			origen: item.origen || '',
			observacion: item.observacion || '',
			id_cat_tipo_ingreso_fondeo: item.id_cat_tipo_ingreso_fondeo || '',
			id_cat_forma_pago_fondeo: item.id_cat_forma_pago_fondeo || '',
			id_cat_destino_fondeo: item.id_cat_destino_fondeo || '',
			fecha_operacion: item.fecha_operacion || null,
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	eliminar = (item) => {
		
		let msg = `¿Deseas eliminar el fondeo de cuenta?`;
		
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			
			if (r.button === 'Eliminar') {
				EstadoCuentasService.EliminarFondeo(item.id_fondeo_cuenta).then((response) => {
					
					this.props.showSnackBars('success', response.mensaje);
					
					this.ListaEstadoCuentaFondeo();
					
				}).catch((error) => {
					
					this.props.showSnackBars('error', error.mensaje);
					
				});
			}
			
		});
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_fondeo_cuenta}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						Fondeo Cuenta
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={1}>
							
							<Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
								
								<KeyboardDatePicker
									format={'dd/MM/yyyy'}
									margin="dense"
									fullWidth
									clearable
									required
									inputProps={{readOnly: true}}
									KeyboardButtonProps={{
										'aria-label': 'change date',
									}}
									label="Fecha de la operación"
									value={this.state.fecha_operacion}
									onChange={(date) => {
										this.handleChange(null, null, null, date, 'fecha_operacion');
									}}
									clearLabel={'Limpiar'}
									okLabel={'Aceptar'}
									cancelLabel={'Cancelar'}
								/>
							
							</Grid>
							
							<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
								<TextField
									select
									fullWidth
									required
									margin="dense"
									onChange={this.handleChange}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_cat_tipo_ingreso_fondeo"
									label="Tipo de ingreso"
									value={this.state.id_cat_tipo_ingreso_fondeo}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.lista_cat_tipo_ingreso_fondeo.map(option => (
										<option key={option.id_cat_tipo_ingreso_fondeo}
										        value={option.id_cat_tipo_ingreso_fondeo}>
											{option.tipo_ingreso_fondeo}
										</option>
									))}
								</TextField>
							</Grid>
							
							<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
								<TextField
									select
									fullWidth
									required
									margin="dense"
									onChange={this.handleChange}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_cat_forma_pago_fondeo"
									label="Forma de pago"
									value={this.state.id_cat_forma_pago_fondeo}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.lista_cat_forma_pago_fondeo.map(option => (
										<option key={option.id_cat_forma_pago_fondeo}
										        value={option.id_cat_forma_pago_fondeo}>
											{option.forma_pago_fondeo}
										</option>
									))}
								</TextField>
							</Grid>
							
							{Number(this.state.id_cat_forma_pago_fondeo) === 1 ? (
								<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
									<TextField
										select
										fullWidth
										required
										margin="dense"
										onChange={this.handleChange}
										SelectProps={{
											native: true,
											MenuProps: {
												className: '',
											},
										}}
										name="id_cat_destino_fondeo"
										label="Destino"
										value={this.state.id_cat_destino_fondeo}
									>
										<option key={0} value={''}>&nbsp;</option>
										<option key={1} value={'1'}>Mostrador</option>
										<option key={2} value={'2'}>Bancos</option>
									</TextField>
								</Grid>
							) : null}
							
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								
								<TextField
									margin="dense"
									name="importe"
									label="Importe"
									type="text"
									fullWidth
									required
									onKeyPress={EnteroSolo}
									defaultValue={this.state.importe}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<TextField
									margin="dense"
									name="origen"
									label="Origen del ingreso"
									type="text"
									fullWidth
									required
									defaultValue={this.state.origen}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<TextField
									margin="dense"
									name="observacion"
									label="Observaciones"
									type="text"
									multiline
									rows={3}
									fullWidth
									defaultValue={this.state.observacion}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<div className={'text-right'}>
									<Button onClick={() => this.save()} variant="contained" color="primary">
										{'Guardar'}
									</Button>
								</div>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<Paper style={{overflowX: "auto"}}>
									<Table className={'desing-mark'}>
										<TableHead>
											<TableRow>
												<TableCell component="th" align={'center'}>N.P.</TableCell>
												<TableCell component="th" align={'left'}>Fecha</TableCell>
												<TableCell component="th" align={'left'}>Tipo de ingreso</TableCell>
												<TableCell component="th" align={'left'}>Forma de pago</TableCell>
												<TableCell component="th" align={'left'}>Importe</TableCell>
												<TableCell component="th" align={'left'}>Origen del recurso</TableCell>
												<TableCell component="th" align={'left'}>Observaciones</TableCell>
												<TableCell component="th" align={'center'}>Acciones</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{this.state.lista_fondeos.length > 0 ?
												<Fragment>
													{this.state.lista_fondeos.map((item, key) => {
														return (
															<Fragment>
																<TableRow key={key}>
																	<TableCell align={'center'}>{key+1}</TableCell>
																	<TableCell align={'left'}>{DateFormat.FormatText(item.fecha_operacion)}</TableCell>
																	<TableCell align={'left'}>{item.tipo_ingreso_fondeo}</TableCell>
																	<TableCell align={'left'}>{item.forma_pago_fondeo}</TableCell>
																	<TableCell align={'left'}>{'$' + FieldsJs.Currency(item.importe)}</TableCell>
																	<TableCell align={'left'}>{item.origen}</TableCell>
																	<TableCell align={'left'}>{item.observacion || 'Sin registrar'}</TableCell>
																	<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
																		<div className={'w-auto vertical-inline'}>
																			
																			<div className={'v-center'}>
																				<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
																					<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
																						<DeleteOutlined/>
																					</IconButton>
																				</Tooltip>
																			</div>
																			
																			<div className={'v-center'}>
																				<ModalFondeoCuentaxId
																					tipo={'edit'}
																					item={item}
																					RefreshList={this.ListaEstadoCuentaFondeo}
																					showSnackBars={this.props.showSnackBars}
																					/>
																			</div>
																			{/*<div className={'v-center'}>
																				<ModalUsuarios id_usuario={item.id_usuario} tipo={'view'}
																				               item={item}
																				               $BroadcastModalUsuarios={this.props.$BroadcastModalUsuarios}/>
																			</div>*/}
																		</div>
																	
																	</TableCell>
																</TableRow>
															</Fragment>
														)
													})}
												</Fragment>
												:
												<TableRow>
													<TableCell colSpan={8} align={'left'}>
														<VistaVacia
															numero={null}
															mensaje={'No se encontraron datos.'}
															image={carrito_de_compra_1}
															// padding={'20px'}
															// paddingText={'20px'}
															height={'80px'}
															width={'80px'}
														/>
													</TableCell>
												</TableRow>
											}
										
										</TableBody>
									</Table>
								</Paper>
							
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<br/>
					
					<DialogActions>
						
						<Fragment>
							<Button onClick={() => this.close()} color="primary">
								{'Cerrar'}
							</Button>
						</Fragment>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalFondeoCuenta.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalFondeoCuenta;
